import { IApplicationState } from '../../../types/types';
import { getRequestsStateInitial } from '../reducers/constants';
import { IRequestsState } from '../reducers/types';

export const getRequestsState = (
    state: IApplicationState
): IRequestsState => {
    return state.requestsState || getRequestsStateInitial();
}
